import BaseBadge from "@reusables/BaseBadge";
import BaseTooltip from "@reusables/BaseTooltip";
import { GlobeCheck, History, ShoppingCart } from "lucide-react";
import { useTranslation } from "react-i18next";

type SalePriceStatusBadgeProps = {
    defaultPriceChanged: boolean | null;
};

type PriceStatus = "defaultPriceChanged" | "salesOrderOnly" | "historical";

const statusConfig = {
    defaultPriceChanged: {
        icon: GlobeCheck,
        variant: "purple",
    },
    salesOrderOnly: {
        icon: ShoppingCart,
        variant: "neutral",
    },
    historical: {
        icon: History,
        variant: "neutral",
    },
} as const;

export default function SalePriceStatusBadge({ defaultPriceChanged }: SalePriceStatusBadgeProps) {
    const { t } = useTranslation("", {
        keyPrefix: "products.viewEditProduct.tabs.prices.table.priceStatuses",
    });

    const status: PriceStatus =
        defaultPriceChanged === null
            ? "historical"
            : defaultPriceChanged
            ? "defaultPriceChanged"
            : "salesOrderOnly";
    const { icon: StatusIcon, variant } = statusConfig[status];

    return (
        <BaseTooltip
            title={`${t(`${status}.tooltip`)}`}
            placement="top"
            wrapperClassName="inline-flex items-center justify-center self-center leading-none"
        >
            <BaseBadge
                variant={variant}
                icon={<StatusIcon size={16} aria-hidden="true" />}
                aria-label={`${t(`${status}.label`)}`}
            />
        </BaseTooltip>
    );
}
